import {createContext} from "react";

const MDropzoneContext = createContext();

export default MDropzoneContext;